import { InfoCircleFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';
import React from 'react';

const options = [
    { label: 'Possible Fingerprinting', value: 'is_fingerprinting', legend: 'Fingerprinting methods identified', tooltip: 'This setting displays all the vendors that are possibly fingerprinting on the vendor trace.' },
    { label: 'Information, Storage & Access', value: 'is_local_storage', legend: 'Cookies, local storage or fingerprinting methods used', tooltip: 'This setting displays all the vendors that are storing identifiers via cookies or local storage on the vendor trace.' },
    { label: 'Prior to consent', value: 'is_prior_to_consent', legend: 'Vendors prior to user consent', tooltip: 'This setting displays all the vendors that were triggered in scans prior to the user accepting all settings on the consent banner.' },
];
const VendorTraceMetricLegend = ({ selectedMetric }) => {
    return (
        <div className={'vendor-trace-metric-legend-container'}>
            <div className={'vendor-trace-prevalence-filter-title-row'}>
                <div>{(options.filter((option) => option.value === selectedMetric))[0].label}</div>
                <Tooltip
                    overlayClassName="vendor-trace-metric-legend-tooltip-overlay"
                    title={() => {
                        return (
                            <div className={'vendor-trace-metric-legend-tooltip-content'}>
                                <div>{(options.filter((option) => option.value === selectedMetric))[0].tooltip}</div>
                            </div>
                        ); 
}
                    }
                >
                    <InfoCircleFilled />
                </Tooltip>
            </div>
            <div className={'vendor-trace-metric-legend-filter-block'}>
                <div className={'color-tags-container'}>
                    <div className={'color-tag'} style={{ backgroundColor: '#6565A9' }} />
                </div>
                <div className={'vendor-trace-prevalence-filter-checkbox-list'}>
                    <div>{(options.filter((option) => option.value === selectedMetric))[0].legend}</div>
                </div>
            </div>
        </div>
    );
};

export default VendorTraceMetricLegend;
